// extracted by mini-css-extract-plugin
export default {"field":"RTSwitch-field-396Z6","on":"RTSwitch-on-23MDt","thumb":"RTSwitch-thumb-3PZMa"};